import React, { useState, useRef } from 'react';
import Button from '../../../components/ui/Button';

const DashboardControls = ({ 
  onExportData,
  onImportData,
  onRefreshData, 
  isLoading,
  isImporting
}) => {
  const fileInputRef = useRef(null);

  const handleImportClick = () => {
    fileInputRef?.current?.click();
  };

  const handleFileChange = (event) => {
    const file = event?.target?.files?.[0];
    if (file && file?.type === 'text/csv') {
      onImportData(file);
    } else if (file) {
      alert('Please select a valid CSV file');
    }
    // Reset file input
    event.target.value = '';
  };

  return (
    <div className="bg-surface border-b border-border px-6 py-4">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        {/* Left side - Title */}
        <div>
          <h1 className="text-2xl font-bold text-text-primary">Training Dashboard</h1>
          <p className="text-sm text-text-secondary">
            Monitor your training load and recovery metrics
          </p>
        </div>

        {/* Right side - Action buttons */}
        <div className="flex items-center gap-3">
          <Button
            variant="outline"
            onClick={handleImportClick}
            loading={isImporting}
            iconName="Upload"
            iconPosition="left"
            disabled={isLoading || isImporting}
          >
            Import CSV
          </Button>
          
          <Button
            variant="outline"
            onClick={onExportData}
            loading={isLoading && !isImporting}
            iconName="Download"
            iconPosition="left"
            disabled={isLoading || isImporting}
          >
            Export CSV
          </Button>
          
          <Button
            variant="outline"
            onClick={onRefreshData}
            loading={isLoading && !isImporting}
            iconName="RefreshCw"
            iconPosition="left"
            disabled={isLoading || isImporting}
          >
            Refresh
          </Button>

          {/* Hidden file input */}
          <input
            ref={fileInputRef}
            type="file"
            accept=".csv"
            onChange={handleFileChange}
            style={{ display: 'none' }}
          />
        </div>
      </div>
    </div>
  );
};

export default DashboardControls;